<template>
	<b-modal ref="profile_modal"
			 size="xl"
			 bodyClass="p-0"
			 v-bind:no-close-on-backdrop=true
			 :hide-header=true
			 v-model="is_show_modal"
			 :dialogClass=dialog_class_draw>

		<template v-slot:modal-header="{ close }">
			<!-- Emulate built in modal header close button action -->
			<b-button size="sm" variant="outline-danger" @click="close()">
				Close Modal
			</b-button>
		</template>

		<!-- BODY -->
		<div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
			<div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
				<h2 >
					<span class="fw-300">ID:{{this.rest.uniq_id}}</span>
				</h2>
				<div class="panel-toolbar pr-3 pb-2 align-self-end">
					<button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
						<i class="fal fa-times"></i>
					</button>
				</div>
			</div>

			<div class="panel-container show">

				<b-overlay :show="is_load" rounded="sm">
					<div class="panel-content">
						<div class="d-flex flex-column align-items-center justify-content-center p-4">
							<h5 class="mb-0 fw-700 text-center mt-3">
								{{this.rest.title}}
								<small class="text-muted mb-0">
									{{__t('rest_info')}}
								</small>
							</h5>
						</div>

						<div>
							<b-tabs content-class="mt-3" @input="tab_opened">
								<b-tab v-for="(tab,index) in tabs" @click="set_active(index)"
									   :disabled="tab.disabled"
									   :title="get_tab_title(tab)"
									   :key="index"
									   :active="tab.is_active"
								>
									<template slot="title">
										{{get_tab_title(tab)}}
										<b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
									</template>

									<component v-bind:is="tab.index" :rest="rest"></component>
								</b-tab>
							</b-tabs>
						</div>
						<div>
						</div>
					</div>

				</b-overlay>
			</div>
			<!--FOOTER -->
		</div>

		<template v-slot:modal-footer="{close}">
			<div class="modal-footer">

				<button type="button" @click="remove()" class="btn btn-outline-danger waves-effect waves-themed mr-5 pl-5 pr-5" v-if="rest_id > 0">
					{{ __t('REMOVE') }}
				</button>

				<button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
					{{ __t('CLOSE') }}
				</button>

				<button type="button" v-on:click="save_rest" class="btn btn-primary waves-effect waves-themed">
					{{ __t('SAVE') }}
				</button>
			</div>
		</template>
	</b-modal>
</template>

<script>
import restaurant_info from "./tabs/restaurant_info.vue";
import restaurant_settings from "./tabs/restaurant_settings.vue";
import restaurant_work from "./tabs/restaurant_work.vue";
import restaurant_zone from "./tabs/restaurant_zone.vue";
import restaurant_tables from "./tabs/tables/restaurant_tables.vue";


//Manana
import restaurant_sms from "./tabs/restaurant_sms.vue";
import restaurant_notification from "./tabs/restaurant_notification.vue";
import poster_connect from "./tabs/poster/poster_connect.vue";

import rest_rkeeper from "./tabs/rkeeper/rest_rkeeper.vue";
import rest_evrasia from "./tabs/evrasia/rest_evrasia.vue";
import rest_privat from "./tabs/privat/rest_privat.vue";


export default {
	name: "resturant_modal",
	components : {
		restaurant_settings,
		restaurant_info,
        restaurant_work,
        restaurant_zone,
        restaurant_tables,
        restaurant_sms,
        restaurant_notification,
        poster_connect,
        rest_evrasia,
        rest_rkeeper,
        rest_privat
	},
	props : {
		modal_position : {
			type : String,
			default : "right"
		},
	},
	data() {
		return {
			rest_id : 0,
			rest: {
				"id" : 0,
				"title" : "",
				"uniq_id" : ""
			},
			is_load: false,
			is_show_modal: false,
			tabs : []
		}
	},

	created () {
		EventBus.$on("restaurant_edit",res => this.work_click(res));
		EventBus.$on("close_rest",this.close);
	},

	methods : {

		work_click(rest_id) {
			this.rest_id = rest_id;
			this.is_show_modal = true;
			this.load_restaurant();
		},

        tab_opened(tab) {
            EventBus.$emit("rest_tab",tab);
        },

		get_tab_title (tab) {
			if(tab.count > 0) {
				return tab.title;
			}
			return tab.title;
		},

		set_active (obj) {
			for (let tab in this.tabs) {
				this.tabs[tab].is_active = false;
			}
			this.tabs[obj].is_active = true;
			EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
		},

		save_rest () {
			EventBus.$emit("save_rest_called");
		},

        async remove() {
            let self = this;
            const is_ok = confirm_me(this.__t("ARE_SURE"));
            is_ok.then(res => {
                self.is_load = true;
                api.delete('/internal/v1/catalog/restaurants/'+ parseInt(this.rest_id)).then(({data}) => {
                    self.is_load = false;
                    if (data.status === "operation_success") {
                        window.location.reload();
                    }
                }).catch(({response}) => {
                    self.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message, type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left"
                    })
                });
            });
        },

		close () {
			this.rest = {
				id : 0,
				title : "",
				uniq_id : "",
			};
			this.rest_id = 0;

			this.tabs = [];
			this.is_show_modal = false;
		},

		async load_restaurant () {
			this.is_load = true;
			this.tabs = [];

			await api.get('/internal/v1/catalog/restaurants/' + this.rest_id).then(({data}) => {
				this.is_load = false;
				if (data.status === "operation_success") {
					this.rest = data.data;
                    this.push_tabs();
				}
			}).catch(({response}) => {
				this.is_load = false;
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
			});
		},

        push_tabs() {
            this.default_tabs.map(item => {
                this.tabs.push({
                    title: item.title,
                    disabled: false,
                    is_active: false,
                    is_load: false,
                    index: item.index,
                    html: ''
                });
            });
        },

        rebuild_tabs() {
            const active_tab = this.tabs.find(tab => tab.is_active);
            const active_index = active_tab ? active_tab.index : null;

            this.tabs = [];
            this.push_tabs();

            if (active_index) {
                const new_active = this.tabs.find(tab => tab.index === active_index);
                if (new_active) {
                    this.tabs.forEach(tab => tab.is_active = false);
                    new_active.is_active = true;
                }
            }
        },
	},
	watch : {
        'rest.is_notify_customer' () {
            this.rebuild_tabs();
        },
	},
	computed : {

        is_evraisa() {
            if(this.rest.hasOwnProperty("provider")) {
                return this.rest.provider === 'sub_evrasia';
            }

            return false;
        },

	    is_poster() {
	        if(this.rest.hasOwnProperty("provider")) {
	            return this.rest.provider === 'sub_poster';
            }

	        return false;
        },

        is_rkeeper() {
            if(this.rest.hasOwnProperty("provider")) {
                return this.rest.provider === 'sub_rkeeper';
            }

            return false;
        },

        default_tabs() {
            let res = [
                {
                    "title": this.__t('MAIN_SETTINGS'),
                    "index": "restaurant_info",
                    is_active:true,
                },
                {
                    "title": this.__t('ADVANCED_SETTINGS'),
                    "index": "restaurant_settings",
                    is_active:false,
                },

                {
                    "title": this.__t('REST.TABLES'),
                    "index": "restaurant_tables",
                    is_active:false,
                },

                {
                    "title": this.__t('REST.WORK_TIME'),
                    "index": "restaurant_work",
                    is_active:false,
                },
                {
                    "title": this.__t('REST.DELIVERY_ZONE'),
                    "index": "restaurant_zone",
                    is_active:false,
                },
               /* {
                    "title": this.__t('REST.PRIVAT'),
                    "index": "rest_privat",
                    is_active:false,
                }*/
              /*  {
                    "title": this.__t('REST.SMS'),
                    "index": "restaurant_sms",
                    is_active:false,
                }*/
            ];

            if(this.rest.is_notify_customer) {
                res.push({
                    title:this.__t('REST.NOTIFICATION'),
                    disabled:false,
                    is_active:false,
                    is_load:false,
                    index:'restaurant_notification',
                    html:''
                });
            }

            if(this.is_poster) {
                res.push({
                    title:'POSTER_CONNECT',
                    disabled:false,
                    is_active:false,
                    is_load:false,
                    index:'poster_connect',
                    html:''
                });
            }

            if(this.is_evraisa) {
                res.push({
                    title:'Evrasia Advanced',
                    disabled:false,
                    is_active:false,
                    is_load:false,
                    index:'rest_evrasia',
                    html:''
                });
            }

            if(this.is_rkeeper) {
                res.push({
                    title:'Rkeeper Advanced',
                    disabled:false,
                    is_active:false,
                    is_load:false,
                    index:'rest_rkeeper',
                    html:''
                });
            }

            return res;
        },


		dialog_class_draw () {
			if(this.modal_position === "left") {
				return "modal-dialog-left modal-lg";
			}

			return "modal-dialog-right modal-lg";
		},
	}

}
</script>

<style scoped>

</style>
